// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/slider_caseList.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/attorney.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./../img/calendar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css'); */

body {
	font-family: 'Poppins', sans-serif;
	font-weight: normal;
	color: #383838;
	font-size: 16px;
	line-height: 24px;
	font-weight: normal;
	overflow-x: hidden;
	background-color: #ffffff;
}

html,
body {
	margin: 0;
	padding: 0;
	height: 100%;
	min-height: 100%;font-family: 'Sora', sans-serif;
}

article,
aside,
canvas,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary {
	display: block;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	font-family: 'Poppins', sans-serif;
}

ul,
li {
	margin: 0;
	padding: 0;
}

a {
	font-family: 'Poppins', sans-serif;
	font-weight: normal;
	font-size: 16px;
	color: #3081CC;
	text-decoration: none;
	transition: all 0.5s ease-out;
}

a:hover {
	text-decoration: underline;
}

a:focus {
	outline: none;
	text-decoration: none;
}

img {
	border: 0 none;
}

p {
	margin: 0 0 15px 0;
}



.logo img {width: 100%; height: auto; aspect-ratio: auto;}
header {
	padding: 25px;
}
header ul.menu {list-style: none;text-align: center;}
header ul.menu li {
	text-align: center;
    display: inline;
    padding: 0 20px;
	position: relative;
	top:4px;
}
header ul.menu li a {
    color: grey;
    padding-left: 10px;
    padding-right: 10px;
    font-weight: 500;
}
header ul.menu li a:hover {text-decoration: none;}
header ul.menu li a.active {
	color: #288DDD;
    border-bottom: 2px solid #288DDD;
    padding-bottom: 5px;
}
header ul.menu2 {
    list-style: none;
    display: inline;
}
header ul.menu2 li {    
	text-align: center;
    display: inline;
    padding: 0 15px;
}
header ul.menu2 li a {
	color: grey;
}
header .searchBar {
    display: inline;
	position: relative;
    margin-left: 30px;
}
header .searchBar input {
    border: 1px solid #bababa;
    border-radius: 4px;
    padding: 5px 10px;
    border-radius: 0 6px 6px 0;width: 290px;
}
header .searchBar button {
	position: absolute;
	right:0;
	top:-6;
    background: #288DDD;
    border: 0;
    padding: 5px 8px;
    border-radius: 0 6px 6px 0;
}
header .searchBar img {}
.seperator {border-right: 2px solid #818181;}
.bold {font-weight: 600;}
.slider {
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-size:cover;
	height:500px;
	width: 100%;
}
.h-100 {
	height: 100%;
}
.slider h1 {
	font-size:72px;
	color:white;
	font-weight:bold;
    padding-top: 60px;
}
.slider .about h1 {
	text-align: center;
    padding-top: 180px;
}
.slider h2 {
	font-size:40px;
	color:white;
	padding-bottom: 15px;
}
.slider .dropdown-select {
	padding:15px 10px;
	border-radius:10px;
}
form {
	margin-top:60px
}
.datePick {padding: 15px;width: 100%;margin-top: 20px;border-radius: 6px;}
.css-13cymwt-control,
.css-t3ipsp-control {padding: 10px;}
.searchForm {
	margin-top:20px;
	border:0;
	border-radius:3px;
	background: #288DDD;
	padding: 15px;
	width: 100%;
	color: white;
	font-size: 20px;
}


.table {margin-top:50px}
.table thead {border-left:0;border-right:0;}
.table thead tr {}
/* .table tbody tr:nth-child(2n+2){
	background-color: rgb(238, 238, 238);
} */
.table thead tr th {font-weight:500;font-size: 14px;}
.table tbody {}
.table tbody tr {font-size:14px;}
.table tbody tr th {}
.table tbody tr td {}
.table tbody tr td div {}
.table tbody tr td div h1 {font-size:14px;color:#288DDD}
.table tbody tr td div p {margin:0;padding:0;}
.table tbody tr td div p span {font-weight:600;margin-right:7px;}
.table tbody img {width:100px}

.table-footer {
    /* background: rgb(238, 238, 238); */
    text-align: center;
    padding: 10px;
	border: 1px solid rgb(220, 220, 220);
}
.table-footer ul {
	list-style: none;
}
.table-footer ul li {
    display: inline;
    padding: 5px;
    color: black;
    font-weight: 500;
    cursor: pointer;
}
.table-footer ul li:hover {
	text-decoration: underline;
}
.table-footer ul li.paginationActive a {font-weight: bold;}
.table-footer ul li a {
	color: black;
}


.attorney {
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	background-size:cover;
	/* height:500px; */
	width: 100%;
	margin-top:50px;
	padding: 50px;
}
.attorney h1 {
	color:white;text-align: center;font-size:25px
}
.attorney input {
	width: 100%;
    background: transparent;
    border: 0;
    border-bottom: 2px solid #288DDD;
	padding: 20px 10px;
    color: #97B7D1;
}
.attorney input::placeholder, textarea::placeholder {
	color:#97B7D1;
}
.attorney label {
	width: 100%;
    background: transparent;
    border: 0;
    /* border-bottom: 2px solid #288DDD; */
    padding: 10px;
    color: #97B7D1;
}
.attorney textarea {    width: 100%;
    background: transparent;
    border: 0;
    border-bottom: 2px solid #288DDD;resize: none;
    padding: 10px;
    color: #97B7D1;}
.attorney button {
	background-color: #288DDD;
	padding: 10px 20px;
    border: 0;
    border-radius: 5px;
	color:white;
	left:50%;
	position:relative;
	transform:translateX(-50%);
	margin-top:20px
}
.attorney-disclaimer-text {
    font-size: 13px;
    padding: 0px 10px;
    color: #97B7D1;
}
.react-datepicker-wrapper:after {
	content: "";
    width: 30px;
    height: 30px;
    position: absolute;
    top: 45%;
    right: 10px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});    
	background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}
.react-datepicker-wrapper {position: relative;}
footer {
	background-color: #133857;
	padding: 20px;
}
footer h1 {
	font-size: 14px;
	color:white;
	font-weight: 300;
	margin-top: 20px;
}
footer ul {list-style: none;display: flex;}
footer ul li {
	text-align: center;
    display: inline;
    padding: 0 20px;
	position: relative;
	top:4px;
}
footer ul li a {
    color: grey;
}
footer .icon {width: 55px;border:1px solid white;border-radius:5px;padding:7px}
footer .icon img {
	width: 100%;
}


.breadcrumb {}
.breadcrumb ul {list-style: none;display: flex;}
.breadcrumb ul li {padding-right: 30px;}
.breadcrumb ul li a.active {color:blue}
.breadcrumb ul li a {}


.about-content {}
.about-content h1 {font-size: 26px;}
.about-content .table-about {
	width: 100%;
	border-bottom: 1px solid #dcdcdc;
	padding: 10px;
}
.about-content .table-about tbody {}
.about-content .table-about tbody tr {
	border-top: 1px solid #dcdcdc;
}
.about-content .table-about thead tr th,
.about-content .table-about tbody tr td {
	padding: 10px;
	vertical-align: baseline;
	/* padding-left:20px; */
}
.about-content .table-about thead tr th {
	font-weight: 600;
	font-size: 14px;
}
.about-content .table-about tbody tr img {
	width: 100px;
    position: relative;
    left: 0%;
    /* transform: translateX(-50%); */
}

.about-content .table-about tbody tr td:first-child,
.about-content .table-about thead tr th:first-child {
	width: 200px;
	/* border-right: 1px solid rgb(193, 193, 193); */
	font-weight: 600;
	padding-left:20px;
	font-size: 14px;
}

.bordered th,
.bordered td {
	/* border: 1px solid rgb(193, 193, 193) */
}
.bordered .align-cent {
	width: 190px;
	text-align:left;
}
.loading-case {
	color: #3081CC;
	margin-top: 20px;
}

.paginationActive {
	color: #333 !important;
}
.searchBarForm {
	display: inline !important;
	margin-top: 0 !important;
}
.wd-cst {width: 130px;}



.loaderBlocker {
	display: none;
}
.loaderBlocker .fadeOut {
	background-color: rgba(0, 0, 0, 0.552);
	width: 100%;
	height: 100%;
	z-index: 1;
	position: fixed;
	top: 0;
	left: 0;
	cursor: wait;
}
.loader {
    border: 10px dotted #ffffff;
    border-radius: 50%;
    border-top: 10px solid #00000000;
    width: 80px;
    height: 80px;
    animation: spin 2s linear infinite;
    position: fixed;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
    transform: translate(-50%,-50%);
    z-index: 2;
}

button > span > p, a > span > p {
	margin: 0px;
	display: inline;
}
  
  /* Safari */
  
  @keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
  }
  /*  Media */
  /* @media (max-width: 1400px) and (min-width: 1024px) {
	header .searchBar input {
		width: auto;
	}
  } */
  @media only screen and (min-width: 1200px) {
  .col-md-7.forcustomdiv {
    justify-content: end;
    display: flex;
	align-items: center;
}
}
@media only screen and (max-width: 1024px) {
	header ul.menu li {
		padding: 0 4px;
	}
	.slider:has(.about) {
		height: 222px;
	}
	.slider h1 {
		font-size: 48px;
		padding-top: 30px;
	}
	.slider h2 {
		line-height: 1rem;
		padding-bottom: 1px;
	}
	.slider form {
		margin-top: 20px;
	}
	header .searchBar {
		margin-left: 10px;
	}
	header .searchBar input {width: 189px;
		font-size: 10px;}
	header ul.menu2 li, header ul.menu2 li a {
		font-size: 14px;
	}
	.slider {
		height: 288px;
	}
	.slider .about h1 {
    padding-top: 80px;
}
	footer .icon {
    width: 47px;
    padding: 3px;
}
footer ul li {
    padding: 0 10px;
}
}
@media (max-width:991px) {
	header ul.menu li{padding: 0 1px;}
	.slider:has(.about) {
		height: 116px!important;
	}
	button.logoutBtn {
    margin-left: 0;
    margin-top: 15px;
    width: 100%;
}
header .searchBar input {
    width: 98%;
}
	.slider .about h1 {
    padding-top: 35px;
}
	.attorney {
    padding-right: 10px;
    padding-left: 10px;
}
	.tableContent {
    overflow-x: auto;
}
	.slider {
    height: auto;
    padding-bottom: 20px;
}
	h2.edit-h2.setContent {
    font-size: 30px;
    padding-bottom: 0px;
}
	h2.edit-h2.setContent p {
    margin-bottom: 0px;
}
	h2.edit-h2.setContent {
    font-size: 30px;
}
	.slider form {
    margin-top: 40px;
}
	.edit-icon.editJs.mt-5 {
    margin-top: 1rem!important;
}
	.slider form {
    margin-top: 20px;
}
.slider h1 {
    font-size: 41px;
    padding-top: 39px;
}
header .searchBar {
    margin-left: 0;
}
header {
    padding: 30px 10px;
}
header ul.menu {
    margin-top: 0px;
    margin-bottom: 30px;
}
header ul.menu li a {
    font-size: 14px;
}
header ul.menu2 {
    margin-bottom: 20px;
    display: block;
	text-align: center;
}

.attorney input,.attorney label {
    font-size: 13px;
}
.slider h2 {
    font-size: 36px;
}
.tableContent > .table {
	min-height: 1800px;
}
}

@media only screen and (max-width: 767px) {
	.bannerTextArea {
		min-height: 280px;
	}
	.about-content h1 {
		font-size: 18px;
	}
	.goodServ {
		font-size: 13px;
	}
	footer ul {
		justify-content: center;
	}
	.slider:has(.about) {
		height: 116px!important;
	}
	button.logoutBtn {
    margin-left: 0;
    margin-top: 15px;
    width: 100%;
}
header .searchBar input {
    width: 98%;
}
	.slider .about h1 {
    padding-top: 35px;
}
	.attorney {
    padding-right: 10px;
    padding-left: 10px;
}
	.tableContent {
    overflow-x: auto;
}
	.slider {
    height: auto;
    padding-bottom: 20px;
}
	h2.edit-h2.setContent {
    font-size: 30px;
    padding-bottom: 0px;
}
	h2.edit-h2.setContent p {
    margin-bottom: 0px;
}
	h2.edit-h2.setContent {
    font-size: 30px;
}
	.slider form {
    margin-top: 40px;
}
	.edit-icon.editJs.mt-5 {
    margin-top: 1rem!important;
}
	.slider form {
    margin-top: 20px;
}

.slider h1 {
    font-size: 41px;
    padding-top: 39px;
}
header .searchBar {
    margin-left: 0;
}
header {
    padding: 30px 10px;
}
header ul.menu {
    margin-top: 15px;
    margin-bottom: 27px;
}
header ul.menu2 {
    margin-bottom: 20px;
    display: block;
	text-align: center;
}

.footerBx p {
    text-align: center;
}
.attorney input,.attorney label {
    font-size: 13px;
}
header ul.menu li a {
    font-size: 17px;
}
}
.exportButton {
	color:#3081CC;
	border: none;
	background:none;
	font-size: 16px;
	padding: 0px;
	font-family: 'Poppins', sans-serif;
}
.exportButton:hover {
	text-decoration: underline;
}
footer .terms-of-use-link {
	text-decoration: none !important;
    color: #ffffff !important;
    font-family: Poppins,sans-serif;
    font-size: 14px;
    font-weight: 300;
}
footer .terms-of-use-link:hover {
	text-decoration: underline;
}

/**
	Captcha CSS
*/
.captcha input[type=text] {
    padding: 12px 20px;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
}
 
canvas{
  /*prevent interaction with the canvas*/
  pointer-events:none;
}


 
.react-confirm-alert-body {
	width: 100% !important;
    color: #666;
}

.react-confirm-alert-body > h1 {
    font-size: 25px !important;
}

.react-confirm-alert-button-group > button {
    background: #288DDD !important;
    font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/custom.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,8FAA8F;;AAE9F;CACC,kCAAkC;CAClC,mBAAmB;CACnB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;;CAEC,SAAS;CACT,UAAU;CACV,YAAY;CACZ,gBAAgB,CAAC,+BAA+B;AACjD;;AAEA;;;;;;;;;;;;;CAaC,cAAc;AACf;;AAEA;;;;;;CAMC,kCAAkC;AACnC;;AAEA;;CAEC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,kCAAkC;CAClC,mBAAmB;CACnB,eAAe;CACf,cAAc;CACd,qBAAqB;CAKrB,6BAA6B;AAC9B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,aAAa;CACb,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;;;AAIA,WAAW,WAAW,EAAE,YAAY,EAAE,kBAAkB,CAAC;AACzD;CACC,aAAa;AACd;AACA,gBAAgB,gBAAgB,CAAC,kBAAkB,CAAC;AACpD;CACC,kBAAkB;IACf,eAAe;IACf,eAAe;CAClB,kBAAkB;CAClB,OAAO;AACR;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;AACA,2BAA2B,qBAAqB,CAAC;AACjD;CACC,cAAc;IACX,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;CACC,kBAAkB;IACf,eAAe;IACf,eAAe;AACnB;AACA;CACC,WAAW;AACZ;AACA;IACI,eAAe;CAClB,kBAAkB;IACf,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B,CAAC,YAAY;AAC3C;AACA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;IACH,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,0BAA0B;AAC9B;AACA,uBAAuB;AACvB,YAAY,+BAA+B,CAAC;AAC5C,OAAO,gBAAgB,CAAC;AACxB;CACC,wDAAgD;CAChD,qBAAqB;CACrB,YAAY;CACZ,WAAW;AACZ;AACA;CACC,YAAY;AACb;AACA;CACC,cAAc;CACd,WAAW;CACX,gBAAgB;IACb,iBAAiB;AACrB;AACA;CACC,kBAAkB;IACf,kBAAkB;AACtB;AACA;CACC,cAAc;CACd,WAAW;CACX,oBAAoB;AACrB;AACA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC;AACD;AACA,WAAW,aAAa,CAAC,WAAW,CAAC,gBAAgB,CAAC,kBAAkB,CAAC;AACzE;qBACqB,aAAa,CAAC;AACnC;CACC,eAAe;CACf,QAAQ;CACR,iBAAiB;CACjB,mBAAmB;CACnB,aAAa;CACb,WAAW;CACX,YAAY;CACZ,eAAe;AAChB;;;AAGA,QAAQ,eAAe;AACvB,cAAc,aAAa,CAAC,cAAc,CAAC;AAC3C,iBAAiB;AACjB;;GAEG;AACH,oBAAoB,eAAe,CAAC,eAAe,CAAC;AACpD,cAAc;AACd,iBAAiB,cAAc,CAAC;AAChC,oBAAoB;AACpB,oBAAoB;AACpB,wBAAwB;AACxB,2BAA2B,cAAc,CAAC,aAAa;AACvD,0BAA0B,QAAQ,CAAC,SAAS,CAAC;AAC7C,+BAA+B,eAAe,CAAC,gBAAgB,CAAC;AAChE,kBAAkB,WAAW;;AAE7B;IACI,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;CAChB,oCAAoC;AACrC;AACA;CACC,gBAAgB;AACjB;AACA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;AACA;CACC,0BAA0B;AAC3B;AACA,wCAAwC,iBAAiB,CAAC;AAC1D;CACC,YAAY;AACb;;;AAGA;CACC,wDAAyC;CACzC,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,aAAa;AACd;AACA;CACC,WAAW,CAAC,kBAAkB,CAAC;AAChC;AACA;CACC,WAAW;IACR,uBAAuB;IACvB,SAAS;IACT,gCAAgC;CACnC,kBAAkB;IACf,cAAc;AAClB;AACA;CACC,aAAa;AACd;AACA;CACC,WAAW;IACR,uBAAuB;IACvB,SAAS;IACT,sCAAsC;IACtC,aAAa;IACb,cAAc;AAClB;AACA,wBAAwB,WAAW;IAC/B,uBAAuB;IACvB,SAAS;IACT,gCAAgC,CAAC,YAAY;IAC7C,aAAa;IACb,cAAc,CAAC;AACnB;CACC,yBAAyB;CACzB,kBAAkB;IACf,SAAS;IACT,kBAAkB;CACrB,WAAW;CACX,QAAQ;CACR,iBAAiB;CACjB,0BAA0B;CAC1B;AACD;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;CACC,WAAW;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,mDAAwC;CAC3C,2BAA2B;IACxB,wBAAwB;IACxB,4BAA4B;AAChC;AACA,2BAA2B,kBAAkB,CAAC;AAC9C;CACC,yBAAyB;CACzB,aAAa;AACd;AACA;CACC,eAAe;CACf,WAAW;CACX,gBAAgB;CAChB,gBAAgB;AACjB;AACA,WAAW,gBAAgB,CAAC,aAAa,CAAC;AAC1C;CACC,kBAAkB;IACf,eAAe;IACf,eAAe;CAClB,kBAAkB;CAClB,OAAO;AACR;AACA;IACI,WAAW;AACf;AACA,cAAc,WAAW,CAAC,sBAAsB,CAAC,iBAAiB,CAAC,WAAW;AAC9E;CACC,WAAW;AACZ;;;AAGA,aAAa;AACb,gBAAgB,gBAAgB,CAAC,aAAa,CAAC;AAC/C,mBAAmB,mBAAmB,CAAC;AACvC,4BAA4B,UAAU;AACtC,qBAAqB;;;AAGrB,gBAAgB;AAChB,mBAAmB,eAAe,CAAC;AACnC;CACC,WAAW;CACX,gCAAgC;CAChC,aAAa;AACd;AACA,mCAAmC;AACnC;CACC,6BAA6B;AAC9B;AACA;;CAEC,aAAa;CACb,wBAAwB;CACxB,uBAAuB;AACxB;AACA;CACC,gBAAgB;CAChB,eAAe;AAChB;AACA;CACC,YAAY;IACT,kBAAkB;IAClB,QAAQ;IACR,iCAAiC;AACrC;;AAEA;;CAEC,YAAY;CACZ,gDAAgD;CAChD,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;;CAEC,yCAAyC;AAC1C;AACA;CACC,YAAY;CACZ,eAAe;AAChB;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;AACA;CACC,0BAA0B;CAC1B,wBAAwB;AACzB;AACA,SAAS,YAAY,CAAC;;;;AAItB;CACC,aAAa;AACd;AACA;CACC,sCAAsC;CACtC,WAAW;CACX,YAAY;CACZ,UAAU;CACV,eAAe;CACf,MAAM;CACN,OAAO;CACP,YAAY;AACb;AACA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,+BAA+B;IAC/B,UAAU;AACd;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;EAEE,WAAW;;EAMX;CACD,KAAK,uBAAuB,EAAE;CAC9B,OAAO,yBAAyB,EAAE;EACjC;EACA,WAAW;EACX;;;;KAIG;EACH;EACA;IACE,oBAAoB;IACpB,aAAa;CAChB,mBAAmB;AACpB;AACA;AACA;CACC;EACC,cAAc;CACf;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,iBAAiB;EACjB,mBAAmB;CACpB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,iBAAiB;CAClB;CACA,yBAAyB,YAAY;EACpC,eAAe,CAAC;CACjB;EACC,eAAe;CAChB;CACA;EACC,aAAa;CACd;CACA;IACG,iBAAiB;AACrB;CACC;IACG,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;AACA;CACC,kBAAkB,cAAc,CAAC;CACjC;EACC,uBAAuB;CACxB;CACA;IACG,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,UAAU;AACd;CACC;IACG,iBAAiB;AACrB;CACC;IACG,mBAAmB;IACnB,kBAAkB;AACtB;CACC;IACG,gBAAgB;AACpB;CACC;IACG,YAAY;IACZ,oBAAoB;AACxB;CACC;IACG,eAAe;IACf,mBAAmB;AACvB;CACC;IACG,kBAAkB;AACtB;CACC;IACG,eAAe;AACnB;CACC;IACG,gBAAgB;AACpB;CACC;IACG,0BAA0B;AAC9B;CACC;IACG,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,cAAc;CACjB,kBAAkB;AACnB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;;AAEA;CACC;EACC,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,uBAAuB;CACxB;CACA;EACC,uBAAuB;CACxB;CACA;IACG,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,UAAU;AACd;CACC;IACG,iBAAiB;AACrB;CACC;IACG,mBAAmB;IACnB,kBAAkB;AACtB;CACC;IACG,gBAAgB;AACpB;CACC;IACG,YAAY;IACZ,oBAAoB;AACxB;CACC;IACG,eAAe;IACf,mBAAmB;AACvB;CACC;IACG,kBAAkB;AACtB;CACC;IACG,eAAe;AACnB;CACC;IACG,gBAAgB;AACpB;CACC;IACG,0BAA0B;AAC9B;CACC;IACG,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,cAAc;CACjB,kBAAkB;AACnB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;AACA;CACC,aAAa;CACb,YAAY;CACZ,eAAe;CACf,eAAe;CACf,YAAY;CACZ,kCAAkC;AACnC;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,gCAAgC;IAC7B,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;AACA;CACC,0BAA0B;AAC3B;;AAEA;;CAEC;AACD;IACI,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;;;AAIA;CACC,sBAAsB;IACnB,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB","sourcesContent":["@charset \"UTF-8\";\n/* @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css'); */\n\nbody {\n\tfont-family: 'Poppins', sans-serif;\n\tfont-weight: normal;\n\tcolor: #383838;\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: normal;\n\toverflow-x: hidden;\n\tbackground-color: #ffffff;\n}\n\nhtml,\nbody {\n\tmargin: 0;\n\tpadding: 0;\n\theight: 100%;\n\tmin-height: 100%;font-family: 'Sora', sans-serif;\n}\n\narticle,\naside,\ncanvas,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection,\nsummary {\n\tdisplay: block;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\tfont-family: 'Poppins', sans-serif;\n}\n\nul,\nli {\n\tmargin: 0;\n\tpadding: 0;\n}\n\na {\n\tfont-family: 'Poppins', sans-serif;\n\tfont-weight: normal;\n\tfont-size: 16px;\n\tcolor: #3081CC;\n\ttext-decoration: none;\n\t-webkit-transition: all 0.5s ease-out;\n\t-moz-transition: all 0.5s ease-out;\n\t-ms-transition: all 0.5s ease-out;\n\t-o-transition: all 0.5s ease-out;\n\ttransition: all 0.5s ease-out;\n}\n\na:hover {\n\ttext-decoration: underline;\n}\n\na:focus {\n\toutline: none;\n\ttext-decoration: none;\n}\n\nimg {\n\tborder: 0 none;\n}\n\np {\n\tmargin: 0 0 15px 0;\n}\n\n\n\n.logo img {width: 100%; height: auto; aspect-ratio: auto;}\nheader {\n\tpadding: 25px;\n}\nheader ul.menu {list-style: none;text-align: center;}\nheader ul.menu li {\n\ttext-align: center;\n    display: inline;\n    padding: 0 20px;\n\tposition: relative;\n\ttop:4px;\n}\nheader ul.menu li a {\n    color: grey;\n    padding-left: 10px;\n    padding-right: 10px;\n    font-weight: 500;\n}\nheader ul.menu li a:hover {text-decoration: none;}\nheader ul.menu li a.active {\n\tcolor: #288DDD;\n    border-bottom: 2px solid #288DDD;\n    padding-bottom: 5px;\n}\nheader ul.menu2 {\n    list-style: none;\n    display: inline;\n}\nheader ul.menu2 li {    \n\ttext-align: center;\n    display: inline;\n    padding: 0 15px;\n}\nheader ul.menu2 li a {\n\tcolor: grey;\n}\nheader .searchBar {\n    display: inline;\n\tposition: relative;\n    margin-left: 30px;\n}\nheader .searchBar input {\n    border: 1px solid #bababa;\n    border-radius: 4px;\n    padding: 5px 10px;\n    border-radius: 0 6px 6px 0;width: 290px;\n}\nheader .searchBar button {\n\tposition: absolute;\n\tright:0;\n\ttop:-6;\n    background: #288DDD;\n    border: 0;\n    padding: 5px 8px;\n    border-radius: 0 6px 6px 0;\n}\nheader .searchBar img {}\n.seperator {border-right: 2px solid #818181;}\n.bold {font-weight: 600;}\n.slider {\n\tbackground-image:url(../img/slider_caseList.png);\n\tbackground-size:cover;\n\theight:500px;\n\twidth: 100%;\n}\n.h-100 {\n\theight: 100%;\n}\n.slider h1 {\n\tfont-size:72px;\n\tcolor:white;\n\tfont-weight:bold;\n    padding-top: 60px;\n}\n.slider .about h1 {\n\ttext-align: center;\n    padding-top: 180px;\n}\n.slider h2 {\n\tfont-size:40px;\n\tcolor:white;\n\tpadding-bottom: 15px;\n}\n.slider .dropdown-select {\n\tpadding:15px 10px;\n\tborder-radius:10px;\n}\nform {\n\tmargin-top:60px\n}\n.datePick {padding: 15px;width: 100%;margin-top: 20px;border-radius: 6px;}\n.css-13cymwt-control,\n.css-t3ipsp-control {padding: 10px;}\n.searchForm {\n\tmargin-top:20px;\n\tborder:0;\n\tborder-radius:3px;\n\tbackground: #288DDD;\n\tpadding: 15px;\n\twidth: 100%;\n\tcolor: white;\n\tfont-size: 20px;\n}\n\n\n.table {margin-top:50px}\n.table thead {border-left:0;border-right:0;}\n.table thead tr {}\n/* .table tbody tr:nth-child(2n+2){\n\tbackground-color: rgb(238, 238, 238);\n} */\n.table thead tr th {font-weight:500;font-size: 14px;}\n.table tbody {}\n.table tbody tr {font-size:14px;}\n.table tbody tr th {}\n.table tbody tr td {}\n.table tbody tr td div {}\n.table tbody tr td div h1 {font-size:14px;color:#288DDD}\n.table tbody tr td div p {margin:0;padding:0;}\n.table tbody tr td div p span {font-weight:600;margin-right:7px;}\n.table tbody img {width:100px}\n\n.table-footer {\n    /* background: rgb(238, 238, 238); */\n    text-align: center;\n    padding: 10px;\n\tborder: 1px solid rgb(220, 220, 220);\n}\n.table-footer ul {\n\tlist-style: none;\n}\n.table-footer ul li {\n    display: inline;\n    padding: 5px;\n    color: black;\n    font-weight: 500;\n    cursor: pointer;\n}\n.table-footer ul li:hover {\n\ttext-decoration: underline;\n}\n.table-footer ul li.paginationActive a {font-weight: bold;}\n.table-footer ul li a {\n\tcolor: black;\n}\n\n\n.attorney {\n\tbackground-image:url(../img/attorney.png);\n\tbackground-size:cover;\n\t/* height:500px; */\n\twidth: 100%;\n\tmargin-top:50px;\n\tpadding: 50px;\n}\n.attorney h1 {\n\tcolor:white;text-align: center;font-size:25px\n}\n.attorney input {\n\twidth: 100%;\n    background: transparent;\n    border: 0;\n    border-bottom: 2px solid #288DDD;\n\tpadding: 20px 10px;\n    color: #97B7D1;\n}\n.attorney input::placeholder, textarea::placeholder {\n\tcolor:#97B7D1;\n}\n.attorney label {\n\twidth: 100%;\n    background: transparent;\n    border: 0;\n    /* border-bottom: 2px solid #288DDD; */\n    padding: 10px;\n    color: #97B7D1;\n}\n.attorney textarea {    width: 100%;\n    background: transparent;\n    border: 0;\n    border-bottom: 2px solid #288DDD;resize: none;\n    padding: 10px;\n    color: #97B7D1;}\n.attorney button {\n\tbackground-color: #288DDD;\n\tpadding: 10px 20px;\n    border: 0;\n    border-radius: 5px;\n\tcolor:white;\n\tleft:50%;\n\tposition:relative;\n\ttransform:translateX(-50%);\n\tmargin-top:20px\n}\n.attorney-disclaimer-text {\n    font-size: 13px;\n    padding: 0px 10px;\n    color: #97B7D1;\n}\n.react-datepicker-wrapper:after {\n\tcontent: \"\";\n    width: 30px;\n    height: 30px;\n    position: absolute;\n    top: 45%;\n    right: 10px;\n    background: url('./../img/calendar.png');    \n\tbackground-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n}\n.react-datepicker-wrapper {position: relative;}\nfooter {\n\tbackground-color: #133857;\n\tpadding: 20px;\n}\nfooter h1 {\n\tfont-size: 14px;\n\tcolor:white;\n\tfont-weight: 300;\n\tmargin-top: 20px;\n}\nfooter ul {list-style: none;display: flex;}\nfooter ul li {\n\ttext-align: center;\n    display: inline;\n    padding: 0 20px;\n\tposition: relative;\n\ttop:4px;\n}\nfooter ul li a {\n    color: grey;\n}\nfooter .icon {width: 55px;border:1px solid white;border-radius:5px;padding:7px}\nfooter .icon img {\n\twidth: 100%;\n}\n\n\n.breadcrumb {}\n.breadcrumb ul {list-style: none;display: flex;}\n.breadcrumb ul li {padding-right: 30px;}\n.breadcrumb ul li a.active {color:blue}\n.breadcrumb ul li a {}\n\n\n.about-content {}\n.about-content h1 {font-size: 26px;}\n.about-content .table-about {\n\twidth: 100%;\n\tborder-bottom: 1px solid #dcdcdc;\n\tpadding: 10px;\n}\n.about-content .table-about tbody {}\n.about-content .table-about tbody tr {\n\tborder-top: 1px solid #dcdcdc;\n}\n.about-content .table-about thead tr th,\n.about-content .table-about tbody tr td {\n\tpadding: 10px;\n\tvertical-align: baseline;\n\t/* padding-left:20px; */\n}\n.about-content .table-about thead tr th {\n\tfont-weight: 600;\n\tfont-size: 14px;\n}\n.about-content .table-about tbody tr img {\n\twidth: 100px;\n    position: relative;\n    left: 0%;\n    /* transform: translateX(-50%); */\n}\n\n.about-content .table-about tbody tr td:first-child,\n.about-content .table-about thead tr th:first-child {\n\twidth: 200px;\n\t/* border-right: 1px solid rgb(193, 193, 193); */\n\tfont-weight: 600;\n\tpadding-left:20px;\n\tfont-size: 14px;\n}\n\n.bordered th,\n.bordered td {\n\t/* border: 1px solid rgb(193, 193, 193) */\n}\n.bordered .align-cent {\n\twidth: 190px;\n\ttext-align:left;\n}\n.loading-case {\n\tcolor: #3081CC;\n\tmargin-top: 20px;\n}\n\n.paginationActive {\n\tcolor: #333 !important;\n}\n.searchBarForm {\n\tdisplay: inline !important;\n\tmargin-top: 0 !important;\n}\n.wd-cst {width: 130px;}\n\n\n\n.loaderBlocker {\n\tdisplay: none;\n}\n.loaderBlocker .fadeOut {\n\tbackground-color: rgba(0, 0, 0, 0.552);\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 1;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tcursor: wait;\n}\n.loader {\n    border: 10px dotted #ffffff;\n    border-radius: 50%;\n    border-top: 10px solid #00000000;\n    width: 80px;\n    height: 80px;\n    animation: spin 2s linear infinite;\n    position: fixed;\n    left: calc(50% - 40px);\n    top: calc(50% - 40px);\n    transform: translate(-50%,-50%);\n    z-index: 2;\n}\n\nbutton > span > p, a > span > p {\n\tmargin: 0px;\n\tdisplay: inline;\n}\n  \n  /* Safari */\n  @-webkit-keyframes spin {\n\t0% { -webkit-transform: rotate(0deg); }\n\t100% { -webkit-transform: rotate(360deg); }\n  }\n  \n  @keyframes spin {\n\t0% { transform: rotate(0deg); }\n\t100% { transform: rotate(360deg); }\n  }\n  /*  Media */\n  /* @media (max-width: 1400px) and (min-width: 1024px) {\n\theader .searchBar input {\n\t\twidth: auto;\n\t}\n  } */\n  @media only screen and (min-width: 1200px) {\n  .col-md-7.forcustomdiv {\n    justify-content: end;\n    display: flex;\n\talign-items: center;\n}\n}\n@media only screen and (max-width: 1024px) {\n\theader ul.menu li {\n\t\tpadding: 0 4px;\n\t}\n\t.slider:has(.about) {\n\t\theight: 222px;\n\t}\n\t.slider h1 {\n\t\tfont-size: 48px;\n\t\tpadding-top: 30px;\n\t}\n\t.slider h2 {\n\t\tline-height: 1rem;\n\t\tpadding-bottom: 1px;\n\t}\n\t.slider form {\n\t\tmargin-top: 20px;\n\t}\n\theader .searchBar {\n\t\tmargin-left: 10px;\n\t}\n\theader .searchBar input {width: 189px;\n\t\tfont-size: 10px;}\n\theader ul.menu2 li, header ul.menu2 li a {\n\t\tfont-size: 14px;\n\t}\n\t.slider {\n\t\theight: 288px;\n\t}\n\t.slider .about h1 {\n    padding-top: 80px;\n}\n\tfooter .icon {\n    width: 47px;\n    padding: 3px;\n}\nfooter ul li {\n    padding: 0 10px;\n}\n}\n@media (max-width:991px) {\n\theader ul.menu li{padding: 0 1px;}\n\t.slider:has(.about) {\n\t\theight: 116px!important;\n\t}\n\tbutton.logoutBtn {\n    margin-left: 0;\n    margin-top: 15px;\n    width: 100%;\n}\nheader .searchBar input {\n    width: 98%;\n}\n\t.slider .about h1 {\n    padding-top: 35px;\n}\n\t.attorney {\n    padding-right: 10px;\n    padding-left: 10px;\n}\n\t.tableContent {\n    overflow-x: auto;\n}\n\t.slider {\n    height: auto;\n    padding-bottom: 20px;\n}\n\th2.edit-h2.setContent {\n    font-size: 30px;\n    padding-bottom: 0px;\n}\n\th2.edit-h2.setContent p {\n    margin-bottom: 0px;\n}\n\th2.edit-h2.setContent {\n    font-size: 30px;\n}\n\t.slider form {\n    margin-top: 40px;\n}\n\t.edit-icon.editJs.mt-5 {\n    margin-top: 1rem!important;\n}\n\t.slider form {\n    margin-top: 20px;\n}\n.slider h1 {\n    font-size: 41px;\n    padding-top: 39px;\n}\nheader .searchBar {\n    margin-left: 0;\n}\nheader {\n    padding: 30px 10px;\n}\nheader ul.menu {\n    margin-top: 0px;\n    margin-bottom: 30px;\n}\nheader ul.menu li a {\n    font-size: 14px;\n}\nheader ul.menu2 {\n    margin-bottom: 20px;\n    display: block;\n\ttext-align: center;\n}\n\n.attorney input,.attorney label {\n    font-size: 13px;\n}\n.slider h2 {\n    font-size: 36px;\n}\n.tableContent > .table {\n\tmin-height: 1800px;\n}\n}\n\n@media only screen and (max-width: 767px) {\n\t.bannerTextArea {\n\t\tmin-height: 280px;\n\t}\n\t.about-content h1 {\n\t\tfont-size: 18px;\n\t}\n\t.goodServ {\n\t\tfont-size: 13px;\n\t}\n\tfooter ul {\n\t\tjustify-content: center;\n\t}\n\t.slider:has(.about) {\n\t\theight: 116px!important;\n\t}\n\tbutton.logoutBtn {\n    margin-left: 0;\n    margin-top: 15px;\n    width: 100%;\n}\nheader .searchBar input {\n    width: 98%;\n}\n\t.slider .about h1 {\n    padding-top: 35px;\n}\n\t.attorney {\n    padding-right: 10px;\n    padding-left: 10px;\n}\n\t.tableContent {\n    overflow-x: auto;\n}\n\t.slider {\n    height: auto;\n    padding-bottom: 20px;\n}\n\th2.edit-h2.setContent {\n    font-size: 30px;\n    padding-bottom: 0px;\n}\n\th2.edit-h2.setContent p {\n    margin-bottom: 0px;\n}\n\th2.edit-h2.setContent {\n    font-size: 30px;\n}\n\t.slider form {\n    margin-top: 40px;\n}\n\t.edit-icon.editJs.mt-5 {\n    margin-top: 1rem!important;\n}\n\t.slider form {\n    margin-top: 20px;\n}\n\n.slider h1 {\n    font-size: 41px;\n    padding-top: 39px;\n}\nheader .searchBar {\n    margin-left: 0;\n}\nheader {\n    padding: 30px 10px;\n}\nheader ul.menu {\n    margin-top: 15px;\n    margin-bottom: 27px;\n}\nheader ul.menu2 {\n    margin-bottom: 20px;\n    display: block;\n\ttext-align: center;\n}\n\n.footerBx p {\n    text-align: center;\n}\n.attorney input,.attorney label {\n    font-size: 13px;\n}\nheader ul.menu li a {\n    font-size: 17px;\n}\n}\n.exportButton {\n\tcolor:#3081CC;\n\tborder: none;\n\tbackground:none;\n\tfont-size: 16px;\n\tpadding: 0px;\n\tfont-family: 'Poppins', sans-serif;\n}\n.exportButton:hover {\n\ttext-decoration: underline;\n}\nfooter .terms-of-use-link {\n\ttext-decoration: none !important;\n    color: #ffffff !important;\n    font-family: Poppins,sans-serif;\n    font-size: 14px;\n    font-weight: 300;\n}\nfooter .terms-of-use-link:hover {\n\ttext-decoration: underline;\n}\n\n/**\n\tCaptcha CSS\n*/\n.captcha input[type=text] {\n    padding: 12px 20px;\n    display: inline-block;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n}\n \ncanvas{\n  /*prevent interaction with the canvas*/\n  pointer-events:none;\n}\n\n\n \n.react-confirm-alert-body {\n\twidth: 100% !important;\n    color: #666;\n}\n\n.react-confirm-alert-body > h1 {\n    font-size: 25px !important;\n}\n\n.react-confirm-alert-button-group > button {\n    background: #288DDD !important;\n    font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
